// Class
import { SmartTagBase } from './smartTagBase';
// Model
import { SmartTagModel } from './smartTag.model';

export class SmartTagMaterialsModel extends SmartTagModel {
	materials?: any[];

	constructor() {
		super();

		this.materials = [];
	}
}

export class SmartTagMaterials extends SmartTagBase {

	/**
	 * Renderer
	 * @param data SmartTagUpdateModel
	 */
	public render(data: SmartTagMaterialsModel, version?: string): string {
		this.getData(data);

		return this.getOutputData(version || 'v1');
	}

	private getData(data: SmartTagMaterialsModel): void{
		const title = data.title || data.subCategory || '';
		const materials = data.materials || [];
		const description = data.description?.trim() || '';

		if (title !== '') {
			this.title = `<span title="${title}">Type: ${title}</span>`;
		}

		if (materials && materials.length > 0) {
			this.addText(`<span title="Materials:">Materials:</span>`);
			materials.forEach((material: any) => {
				this.addText(`<span title="${material.typeName}">&nbsp;&nbsp;&nbsp;&nbsp;${material.typeName}</span>`);
			});
		}

		if (description !== '') {
			this.addText(`<span title="${description}">Description: ${description}</span>`);
		}
	}
}
